import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 bg-gym-charcoal" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-gym-dark p-10 md:p-16 rounded-3xl border border-gym-gold/30 text-center shadow-[0_0_40px_rgba(212,168,67,0.1)]" data-id="element-139">
          <div className="flex justify-center mb-8" data-id="element-140">
            <ShieldCheck size={64} className="text-gym-gold" data-id="element-141" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 uppercase tracking-wide text-white" data-id="element-142">
            Nuestra Promesa —{' '}
            <span className="text-gym-gold" data-id="element-143">Sin riesgo para ti</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed font-body max-w-2xl mx-auto" data-id="element-144">
            <p data-id="element-145">Vienes. Entrenas. Te orientamos. Te evaluamos.</p>
            <p data-id="element-146">
              Si al terminar tu clase gratis sientes que esto no es para ti, te
              vas sin compromiso, sin presión, sin llamadas molestas.
            </p>

            <div className="my-10 p-6 bg-gym-charcoalLight rounded-xl border border-gym-charcoal" data-id="element-147">
              <p className="text-3xl font-heading font-bold text-white uppercase tracking-wider" data-id="element-148">
                Zero riesgo.{' '}
                <span className="text-gym-gold" data-id="element-149">Zero presión.</span>
              </p>
            </div>

            <p className="italic" data-id="element-150">
              Pero si sientes — como la mayoría siente — que esto es exactamente
              lo que necesitabas...
            </p>
            <p className="text-2xl font-bold text-white mt-4 uppercase tracking-wide" data-id="element-151">
              entonces bienvenido a tu nueva vida.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}